import React from "react";
import { useLang } from "../lib/i18n";

const TILES = [
  // Ανοιχτές κούτες με προϊόντα μέσα — πρώτα
  {
    src: "/gifts/premium-open.jpg",
    title: { el: "Premium Gift Box — Ανοιχτό", en: "Premium Gift Box — Opened", bg: "Премиум · Отворена", ru: "Премиум · Открыто" },
    sub: { el: "6 προϊόντα · Το πλήρες σετ", en: "6 products · full set", bg: "6 продукта · пълен комплект", ru: "6 продуктов · полный набор" },
  },
  {
    src: "/gifts/heritage-open.jpg",
    title: { el: "Heritage Κουτί — Ανοιχτό", en: "Heritage Box — Opened", bg: "Херитидж · Отворена", ru: "Heritage · Открыто" },
    sub: { el: "5 προϊόντα εν όψει", en: "5 products revealed", bg: "5 продукта разкрити", ru: "5 продуктов раскрыты" },
  },
  {
    src: "/gifts/essentials-open.jpg",
    title: { el: "Essentials Καλάθι — Ανοιχτό", en: "Essentials Basket — Opened", bg: "Есеншълс · Отворена", ru: "Essentials · Открыто" },
    sub: { el: "3 κλασικά ελληνικά", en: "3 Greek classics", bg: "3 гръцки класики", ru: "3 греческих классика" },
  },
  // Κλειστές κούτες
  {
    src: "/gifts/premium.jpg",
    title: { el: "Premium Gift Box", en: "Premium Gift Box", bg: "Премиум Кутия", ru: "Премиум Коробка" },
    sub: { el: "Έτοιμο για δώρο", en: "Ready to gift", bg: "Готова за подарък", ru: "Готова к подарку" },
  },
  {
    src: "/gifts/heritage.jpg",
    title: { el: "Heritage Κουτί", en: "Heritage Box", bg: "Херитидж Кутия", ru: "Heritage Коробка" },
    sub: { el: "Ξενοδοχεία & εταιρικά", en: "Hotels & Corporate", bg: "Хотели & Корпоративни", ru: "Отели & Корпоративные" },
  },
  {
    src: "/gifts/essentials.jpg",
    title: { el: "Essentials Καλάθι", en: "Essentials Basket", bg: "Есеншълс Кошница", ru: "Essentials Корзина" },
    sub: { el: "Διακριτικό αυθεντικό δώρο", en: "Discreet authentic gift", bg: "Дискретен подарък", ru: "Изысканный подарок" },
  },
  // Προϊόντα
  {
    src: "/products/oil-500.jpg",
    title: { el: "Extra Virgin Ελαιόλαδο", en: "Extra Virgin Olive Oil", bg: "Екстра върджин зехтин", ru: "Оливковое масло Extra Virgin" },
    sub: { el: "Ψυχρή έκθλιψη · οξύτητα 0.3%", en: "Cold-pressed · 0.3% acidity", bg: "Студено пресован", ru: "Холодный отжим" },
  },
  {
    src: "/products/honey-450.jpg",
    title: { el: "Θυμαρίσιο Μέλι", en: "Thyme Honey", bg: "Мащеркен мед", ru: "Тимьяновый мёд" },
    sub: { el: "Άγριο μέλι · Κρήτη", en: "Wild honey · Crete", bg: "Див мед · Крит", ru: "Дикий мёд · Крит" },
  },
  {
    src: "/products/wine-750.jpg",
    title: { el: "Ασύρτικο & Λιάτικο", en: "Assyrtiko & Liatiko", bg: "Асиртико & Лиатико", ru: "Ассиртико и Лиатико" },
    sub: { el: "Παραδοσιακά κρητικά κρασιά", en: "Traditional Cretan wines", bg: "Традиционни критски вина", ru: "Традиционные вина Крита" },
  },
  {
    src: "/products/olives-350.jpg",
    title: { el: "Ελιές Καλαμών", en: "Kalamon Olives", bg: "Каламонски маслини", ru: "Оливки Каламон" },
    sub: { el: "PDO · Χειροπανιά", en: "PDO · Hand-harvested", bg: "Ръчно бране", ru: "Ручной сбор" },
  },
  {
    src: "/products/raki-500.jpg",
    title: { el: "Κρητική Ρακή", en: "Cretan Raki", bg: "Критска ракия", ru: "Критская ракия" },
    sub: { el: "Παραδοσιακό απόσταγμα", en: "Traditional distillate", bg: "Традиционен дестилат", ru: "Традиционный дистиллят" },
  },
  {
    src: "/products/rusks-500.jpg",
    title: { el: "Κρητικά Παξιμάδια", en: "Cretan Rusks", bg: "Критски сухари", ru: "Критские сухарики" },
    sub: { el: "Ολικής · ξυλόφουρνος", en: "Whole grain · wood oven", bg: "Пълнозърнести", ru: "Цельнозерновые" },
  },
];

const HEADERS = {
  el: { eyebrow: "Τα Προϊόντα μας", title: "Πολυτελή δώρα ", titleEm: "για κάθε στιγμή.", lead: "Οι κούτες και τα εκλεκτά προϊόντα Golden Elia — από την Κρήτη με φροντίδα, ιδανικά για δώρο ή για το τραπέζι σας." },
  en: { eyebrow: "Our Products", title: "Luxury gifts ", titleEm: "for every moment.", lead: "Golden Elia gift boxes and curated products — from Crete with care, ideal for gifting or your own table." },
  bg: { eyebrow: "Нашите продукти", title: "Луксозни подаръци ", titleEm: "за всеки момент.", lead: "Кутиите и подбраните продукти Golden Elia — от Крит с грижа, идеални за подарък или собствената ви маса." },
  ru: { eyebrow: "Наши продукты", title: "Роскошные подарки ", titleEm: "для каждого момента.", lead: "Подарочные коробки и отборные продукты Golden Elia — с Крита с заботой, идеально для подарка или вашего стола." },
};

export const Gallery = () => {
  const { lang } = useLang();
  const h = HEADERS[lang] || HEADERS.en;

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-28 sm:py-40 px-6"
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-16 sm:mb-20 text-center">
          <p className="font-display text-[10px] tracking-[0.55em] text-[color:var(--goldenelia-gold)] uppercase mb-6">
            {h.eyebrow}
          </p>
          <h2 className="font-serif-luxury text-4xl sm:text-5xl lg:text-6xl gold-gradient-text mb-6 leading-[1.1]">
            {h.title}
            <em className="italic font-light text-[color:var(--goldenelia-cream)]/80">{h.titleEm}</em>
          </h2>
          <div className="gold-divider max-w-xs mx-auto mb-6">
            <span className="diamond" />
          </div>
          <p className="font-serif-luxury italic text-lg sm:text-xl text-[color:var(--goldenelia-cream)]/80 max-w-2xl mx-auto leading-relaxed">
            {h.lead}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[color:var(--goldenelia-gold)]/15">
          {TILES.map((tile, i) => (
            <div
              key={tile.src}
              data-testid={`gallery-tile-${i}`}
              className="group relative block aspect-[4/5] overflow-hidden bg-black"
            >
              <img
                src={tile.src}
                alt={tile.title[lang] || tile.title.en}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-[1.08]"
              />
              {/* Dark gradient overlay for legible captions */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/20 group-hover:from-black/70 transition-colors duration-700" />
              <div className="absolute inset-0 border border-transparent group-hover:border-[color:var(--goldenelia-gold)]/50 transition-colors duration-500" />

              {/* Caption */}
              <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6 z-10">
                <p className="font-display text-[9px] sm:text-[10px] tracking-[0.45em] uppercase text-[color:var(--goldenelia-gold)] mb-2">
                  {tile.sub[lang] || tile.sub.en}
                </p>
                <h3 className="font-serif-luxury text-xl sm:text-2xl text-[color:var(--goldenelia-cream)] leading-tight">
                  {tile.title[lang] || tile.title.en}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center mt-10 sm:mt-14 font-body text-[11px] sm:text-xs tracking-[0.3em] uppercase text-[color:var(--goldenelia-cream)]/40">
          @goldenelia_2026 · #greektreasure
        </p>
      </div>
    </section>
  );
};

export default Gallery;
